// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3iygy","loaderOuter":"PageOverlayLoader_loaderOuter__yy6RC"};